import * as React from 'react';

import { Wrapper } from './styles';
import Image from '../Image';
import { ThumbnailData } from '../../constants';
import { ShowAloneSide } from '../../../../../containers/Editor/constants';

interface ImageWrapperProps {
	thumbnailsData: ThumbnailData[];
}

const ImageWrapper = ({ thumbnailsData }: ImageWrapperProps) => (
	<Wrapper>
		{thumbnailsData.map(({ imageSrc }, index) => {
			let side = ShowAloneSide.CENTER;

			if (thumbnailsData.length > 1) {
				side = index === 0 ? ShowAloneSide.LEFT : ShowAloneSide.RIGHT;
			}

			return (
				<Image
					key={index}
					imageSrc={imageSrc}
					side={side}
				/>
			);
		})}
	</Wrapper>
);

export default ImageWrapper;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Thumbnails/Item/ImageWrapper/index.tsx